import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../redux/hooks";

import { UsersListInterface } from "../../../../../redux/interfaces/admin.interface";

import "moment/locale/ro";

import Dropdown, {
  DropdownValue,
} from "../../../../../components/misc/Dropdown";
import {
  getCurrentYearOrMonth,
  getDaysOfMonthBeforeToday,
  getMonthsBeforeToday,
  monthsDataDropdownValue,
} from "../../../../../utils/dateAndTime";
import useTableCtx from "../../../../../components/tables/tableContext/useTableCtx";

const lastThreeYears = [
  getCurrentYearOrMonth("year"),
  getCurrentYearOrMonth("year") - 1,
  getCurrentYearOrMonth("year") - 2,
];

const yearsDataDropdownValue = lastThreeYears.map((year: number) => {
  return {
    id: year,
    label: year,
  };
});

const allOption = {
  id: 0,
  label: "Toate",
};

function CollectionErrorsDropdwonsHeader() {
  const { handleTableSearch } = useTableCtx() || {};

  const {
    admin: {
      users: {
        data: { data: users },
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  const [selectedDay, setSelectedDay] = useState<DropdownValue>(allOption);
  const [selectedMonth, setSelectedMonth] = useState<DropdownValue>(
    monthsDataDropdownValue[getCurrentYearOrMonth("month")],
  );
  const [selectedYear, setSelectedYear] = useState<DropdownValue>(
    yearsDataDropdownValue[0],
  );
  const [selectedUsers, setSelectedUsers] = useState<DropdownValue[]>([]);

  const daysOfMonthBeforeToday = getDaysOfMonthBeforeToday(
    selectedMonth.id,
    selectedYear.id,
  );

  const daysDropdownValue = daysOfMonthBeforeToday.map((day) => {
    return {
      id: parseInt(day),
      label: day,
    };
  });

  const daysDropdownValueWithAll = [
    { id: 0, label: "Toate" },
    ...daysDropdownValue,
  ];

  const monthsDropdownValue = getMonthsBeforeToday(selectedYear.id);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedDay", selectedDay?.id);
  }, [handleTableSearch, selectedDay]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedMonth", selectedMonth?.id);
  }, [handleTableSearch, selectedMonth]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedYear", selectedYear?.id);
  }, [handleTableSearch, selectedYear]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedUsers", JSON.stringify(selectedUsers));
  }, [handleTableSearch, selectedUsers]);

  const usersDropdownValue = users.map((user: UsersListInterface) => {
    return {
      id: user.userId,
      label: user.userName,
    };
  });

  return (
    <div className="d-flex justify-content-center">
      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza ziua"
        data={daysDropdownValueWithAll}
        singleValue={selectedDay}
        setSingleValue={(value) => value && setSelectedDay(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza luna"
        data={monthsDropdownValue}
        singleValue={selectedMonth}
        setSingleValue={(value) => value && setSelectedMonth(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza anul"
        data={yearsDataDropdownValue}
        singleValue={selectedYear ?? yearsDataDropdownValue[0]}
        setSingleValue={(value) => value && setSelectedYear(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Username colector"
        data={usersDropdownValue}
        multipleValues={selectedUsers}
        setMultipleValues={setSelectedUsers}
      />
    </div>
  );
}

export default CollectionErrorsDropdwonsHeader;
